<template>
  <div class="q-pa-md" id="test-exception">
    <!-- Carregando verificação de acesso -->
    <div v-if="autorizado === null" class="row items-center q-gutter-sm">
      <q-spinner size="24px" />
      <span>Verificando acesso…</span>
    </div>

    <!-- Acesso negado (usuário não é o suporte) -->
    <q-banner
      v-else-if="autorizado === false"
      class="bg-red-1 text-red-9"
      rounded
    >
      <template v-slot:avatar>
        <q-icon name="lock" color="red" />
      </template>
      Acesso restrito. Esta tela é exclusiva do usuário de suporte
      (<strong>suporte@dourasoft.net</strong>).
      <template v-slot:action>
        <q-btn flat color="red-9" label="Voltar" @click="$router.push('/')" />
      </template>
    </q-banner>

    <!-- Autorizado: tela de teste -->
    <q-card v-else flat bordered class="test-card">
      <q-card-section>
        <div class="text-h6">Teste de captura de erros (Sentry)</div>
        <div class="text-caption text-grey-7">
          Ambiente: <strong>{{ environment }}</strong> ·
          Logado como <strong>{{ email }}</strong>
        </div>
      </q-card-section>

      <q-separator />

      <q-card-section class="q-gutter-md">
        <div>
          <q-btn
            color="negative"
            icon="cloud_off"
            label="Lançar exceção no BACKEND"
            :loading="carregandoBackend"
            @click="dispararErroBackend"
          />
          <div class="text-caption text-grey-7 q-mt-xs">
            Chama <code>GET /test-exception/throw</code> → 500 → projeto PHP no Sentry.
          </div>
        </div>

        <div>
          <q-btn
            color="deep-orange"
            icon="bug_report"
            label="Lançar exceção no FRONTEND"
            @click="dispararErroFrontend"
          />
          <div class="text-caption text-grey-7 q-mt-xs">
            Lança um erro no Vue → projeto JS no Sentry (com Session Replay).
          </div>
        </div>
      </q-card-section>
    </q-card>
  </div>
</template>

<script>
import { createMetaMixin } from "quasar";
import axios from "@/axios-auth";

export default {
  name: "test_exception",
  mixins: [createMetaMixin({ title: "DSB | Teste de Exceções" })],
  data() {
    return {
      // null = verificando, true = autorizado, false = negado
      autorizado: null,
      email: "",
      environment: process.env.VUE_APP_SENTRY_ENVIRONMENT || process.env.NODE_ENV,
      carregandoBackend: false
    };
  },
  async mounted() {
    // O backend é a fonte de verdade da autorização (reusa toda a segurança e
    // checa o email). Só responde 200 para o suporte; qualquer outro = 403.
    const res = await axios.get("/test-exception");
    if (res && res.data && res.data.success) {
      this.autorizado = true;
      this.email = res.data.email;
    } else {
      this.autorizado = false;
    }
  },
  methods: {
    async dispararErroBackend() {
      this.carregandoBackend = true;
      // Espera-se HTTP 500. O interceptor de resposta transforma o erro em
      // { error }, então não cai no catch — o objetivo é o backend lançar a
      // exceção e o Sentry capturá-la.
      await axios.get("/test-exception/throw");
      this.carregandoBackend = false;
      this.$q.notify({
        color: "orange",
        position: "top-right",
        message: "Exceção disparada no backend. Verifique o Sentry (projeto API)."
      });
    },
    dispararErroFrontend() {
      this.$q.notify({
        color: "deep-orange",
        position: "top-right",
        message: "Exceção disparada no frontend. Verifique o Sentry (projeto JS)."
      });
      // Erro real e não tratado → capturado pelo @sentry/vue (Vue.config.errorHandler).
      throw new Error(
        "[Teste Sentry] Exceção proposital no frontend (tela /test-exception)."
      );
    }
  }
};
</script>

<style scoped>
.test-card {
  max-width: 560px;
}
</style>
